<ion-list-header>
  <ion-label>{{ 'menu.deviceSettings.storageInformation.title' | transloco }}</ion-label>
</ion-list-header>

@if (storageInformation$$()) {
  <ion-list [inset]="true">
    @if (storageInformation$$().totalAllocatedPercent) {
      <ion-item>
        <ion-progress-bar [value]="storageInformation$$().totalAllocatedPercent ?? 0"></ion-progress-bar>
      </ion-item>
    }
    <ion-item>
      <ion-icon name="ellipse" class="total" slot="start" />
      <ion-label>{{ 'menu.deviceSettings.storageInformation.total' | transloco }}</ion-label>
      <ion-note slot="end">{{ storageInformation$$().totalStorageSize | formatStorageSize }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-icon name="ellipse" class="other-apps" slot="start" />
      <ion-label>{{ 'menu.deviceSettings.storageInformation.otherApps' | transloco }}</ion-label>
      <ion-note slot="end">{{ storageInformation$$().allocatedByOtherApps | formatStorageSize }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-icon name="ellipse" class="allocated" slot="start" />
      <ion-label>{{ 'menu.deviceSettings.storageInformation.cache' | transloco }}</ion-label>
      <ion-note slot="end">{{ storageInformation$$().allocatedByOurApp | formatStorageSize }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-icon name="ellipse" class="free" slot="start" />
      <ion-label>{{ 'menu.deviceSettings.storageInformation.free' | transloco }}</ion-label>
      <ion-note slot="end">{{ storageInformation$$().freeStorageSize | formatStorageSize }}</ion-note>
    </ion-item>
  </ion-list>
}
